module.exports = __webpack_public_path__ + "img/9.c4eb5820.jpg";